import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import {
  checkForRemoteBuildUpdate,
  initializeClientBuildIdentity,
} from '../../../../services/clientVersion';

const ClientVersionManager = () => {
  useEffect(() => {
    let appStateListener: PluginListenerHandle | null = null;
    let isUnmounted = false;

    const runVersionCheck = () => {
      void checkForRemoteBuildUpdate();
    };

    const setup = async () => {
      await initializeClientBuildIdentity();
      if (isUnmounted) {
        return;
      }

      runVersionCheck();

      if (Capacitor.isNativePlatform()) {
        appStateListener = await App.addListener(
          'appStateChange',
          ({ isActive }) => {
            if (isActive) {
              runVersionCheck();
            }
          }
        );
      }
    };

    void setup();

    const onWindowFocus = () => {
      runVersionCheck();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        runVersionCheck();
      }
    };

    if (!Capacitor.isNativePlatform()) {
      window.addEventListener('focus', onWindowFocus);
      document.addEventListener('visibilitychange', onVisibilityChange);
    }

    return () => {
      isUnmounted = true;

      if (!Capacitor.isNativePlatform()) {
        window.removeEventListener('focus', onWindowFocus);
        document.removeEventListener('visibilitychange', onVisibilityChange);
      }

      if (appStateListener) {
        void appStateListener.remove();
      }
    };
  }, []);

  return null;
};

export default ClientVersionManager;
